import React from 'react';

import {Button, Card} from "antd";
import {clearTokensAndRedirect} from "@/lib/services/tokenService";
import {useAuth} from "@/provider/AuthProvider";
import {useApiAuthLogout} from "@/api/auth";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import AuthLayout from "@/components/layout/auth/AuthLayout";

function AuthLogoutPage(props) {

    const {user} = useAuth();
    const {mutate: authLogout, isPending} = useApiAuthLogout()

    function logout() {
        authLogout({}, {
            onSuccess: function () {
                clearTokensAndRedirect()
            }
        })

    }

    return (
        <AuthLayout>
            <Card>
                <div>
                    <div className="text-2xl text-center">خروج از حساب کاربری</div>
                    <div className={'text-center'}>
                        <br/>
                        {user?.displayname}
                        {' '}
                        عزیز
                        <br/>
                        <br/>
                        برای خروج از حساب کاربری کلیک کنید
                    </div>
                </div>
                <div>

                    <Button
                        loading={isPending}
                        onClick={() => logout()}
                        type="primary" className="w-full mt-8">
                        خروج
                    </Button>

                    <Button type={'link'} className={'w-full mt-8'}>
                        <Link to={URLS.gateway.selector}>ادامه</Link>
                    </Button>

                </div>
            </Card>
        </AuthLayout>
    );
}

export default AuthLogoutPage;